import * as PIXI from "pixi.js";
import { useEffect, useRef } from "react";
import styles from "./index.module.scss";
import displacement_map_repeat from "./displacement_map_repeat.jpg";

export function FlagImage({ src }: any) {
  const ref = useRef<any>();

  useEffect(
    function () {
      let refCur = ref.current;
      const app = new PIXI.Application({
        resizeTo: refCur,
        backgroundAlpha: 0,
      });

      refCur.appendChild(app.view);
      app.stage.eventMode = "static";

      const container = new PIXI.Container();
      app.stage.addChild(container);

      const flag = PIXI.Sprite.from(src);

      container.addChild(flag);
      flag.x = 0;
      flag.y = 0;

      const displacementSprite = PIXI.Sprite.from(displacement_map_repeat);
      // Make sure the sprite is wrapping.

      displacementSprite.texture.baseTexture.wrapMode = PIXI.WRAP_MODES.REPEAT;
      const displacementFilter = new PIXI.DisplacementFilter(
        displacementSprite
      );

      displacementFilter.padding = 0;
      displacementSprite.position = flag.position;

      app.stage.addChild(displacementSprite);

      flag.filters = [displacementFilter];

      displacementFilter.scale.x = 300;
      displacementFilter.scale.y = 20;

      app.ticker.add(() => {
        // Offset the sprite position to make vFilterCoord update to larger value.
        // Repeat wrapping makes sure there's still pixels on the coordinates.
        displacementSprite.x++;
        // Reset x to 0 when it's over width to keep values from going to very huge numbers.
        if (displacementSprite.x > displacementSprite.width) {
          displacementSprite.x = 0;
        }
      });

      return function () {
        app.destroy();
        if (app.view) {
          refCur.appendChild(app.view);
        }
      };
    },
    [src]
  );

  return <div className={styles.flagImage} ref={ref}></div>;
}
